



import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FormStepper from '../components/FormStepper';
import EmploymentSection from "../components/EmploymentSection"
import EducationSection from "../components/EducationSection"
import LicenseSection from "../components/LicenseSection"
import PersonalInfoSection from './PersonalInfoSection';
import { SUBMIT_FORM_URL } from '../constants';


export default function FormPage() {
const location = useLocation();
const company = location.state?.company;


  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);



  const totalSteps = 4;

  const [personalInfo, setPersonalInfo] = useState({
    fullName: '',
    dob: '',
    contact: '',
    idType: '',
    idFile: null,
  });
  

  const [employmentList, setEmploymentList] = useState([
    {
      id: Date.now(),
      company: '',
      position: '',
      duration: '',
      responsibilities: '',
      reason: '',
    },
  ]);

  const [educationList, setEducationList] = useState([
    {
      id: Date.now(),
      institution: '',
      degree: '',
      startDate: '',
      endDate: '',
      studentNumber: '',
      certNumber: '',
      certificateFile: null,
    },
  ]);

  const [licenses, setLicenses] = useState([
    { id: Date.now(), title: '', number: '', file: null },
  ]);
  
const handleSubmit = async () => {
    setLoading(true); // start loading
    const payload = {
      companyId: company?.id,
      personalInfo,
      employmentList,
      educationList: educationList.map(e => ({
        institution: e.institution,
        degree: e.degree,
        startDate: e.startDate,
        endDate: e.endDate,
        studentNumber: e.studentNumber,
        certNumber: e.certNumber,
      })),
      licenses: licenses.map(l => ({
        title: l.title,
        number: l.number,
      })),
    };
  
    try {
      const res = await fetch(SUBMIT_FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      });
  
      const data = await res.json();
  
      if (!res.ok) {
        toast.error(data.message || 'Something went wrong');
        setLoading(false); // stop loading if error
        return;
      }
  
      toast.success('Preparing Checkout...');
      setTimeout(() => {
        if (company?.paymentLink) {
          window.location.href = company.paymentLink;
        } else {
          toast.info('No payment link found.');
        }
      }, 1500);
  
    } catch (err) {
      console.error('Submission Error:', err);
      toast.error('Failed to submit form. Please try again.');
    } finally {
      setLoading(false); // always stop loading after try/catch
    }
  };
  
const handleNext = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    } else {
      handleSubmit(); // Final step: trigger form submission
    }
  };
  
  

  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  return (
    <div className="min-h-screen px-4 py-8 bg-white text-gray-800">
         <ToastContainer position="top-right" />
      <div className="max-w-4xl mx-auto">
        <h1 className="text-2xl font-bold text-center mb-4">
          Welcome to BC Verification Service
        </h1>
        {/* <p className="text-sm text-center text-gray-600 mb-8 leading-relaxed">
          We are dedicated to seamlessly integrating international qualifications...

        </p> */}
       <div className="bg-white rounded-xl p-6 mb-10 shadow  text-gray-700 text-xs leading-relaxed">
  <p>
    We help you align international academic and professional qualifications with UK standards through credential verification and issuance of a Statement of Comparability.
  </p>
  <p className="mt-4">
    All documents are cross-validated for authenticity with institutions in your country of issuance. Please upload any certifications or licenses relevant to your role.
  </p>
  <p className="mt-4">
    Our streamlined process ensures fast results, typically within 10 working days, at competitive rates for selected countries.
  </p>
  <p className="mt-4">
    Your qualifications deserve recognition. We help you move forward with confidence in the UK job market.
  </p>
</div>



        {/* Stepper */}
        <FormStepper currentStep={step} />

        {/* Step Content */}
        <div className="mb-6">
                    {step === 1 && (
            <PersonalInfoSection
                personalInfo={personalInfo}
                setPersonalInfo={setPersonalInfo}
            />
            )}

          {step === 2 && (
            <EmploymentSection
                employmentList={employmentList}
                setEmploymentList={setEmploymentList}
            />
            )}

            {step === 3 && (
            <EducationSection
                educationList={educationList}
                setEducationList={setEducationList}
            />
            )}

        {step === 4 && (
        <LicenseSection licenses={licenses} setLicenses={setLicenses} />
        )}


        </div>

   {/* Navigation Buttons */}
<div className="flex justify-between gap-4">
  {step > 1 && (
    <button
      onClick={handleBack}
      className="w-full bg-primary text-white py-2 rounded-full"
      disabled={loading}
    >
      Previous
    </button>
  )}
  <button
    onClick={handleNext}
    className="w-full bg-primary text-white py-2 rounded-full disabled:opacity-60"
    disabled={loading}
  >
    {loading
      ? 'Preparing Checkout...'
      : step === totalSteps
      ? 'Checkout With Local Currency'
      : 'Next'}
  </button>
</div>
      </div>
    </div>
  );
}

